<template>
    <div>
        <navTitle :title="$router.app._route.query.ti ? $router.app._route.query.ti : 'Chọn kênh nạp tiền'"></navTitle>
        <div class="amount">
            <label class="amount-title">số lượng</label>
            <label class="query-amount">₫{{money}}</label>
        </div>
        <div class="channel">
            <div v-for="(v,k) in channel_list" :key="k">
                <div class="name" @click="getRadioVal(v)">
                    <svg v-if="channel===v.value" t="1662600739499" class="icon" viewBox="0 0 1024 1024" version="1.1"
                         xmlns="http://www.w3.org/2000/svg" p-id="2573" width="72" height="72">
                        <path d="M512 85.333333C277.333333 85.333333 85.333333 277.333333 85.333333 512s192 426.666667 426.666667 426.666667 426.666667-192 426.666667-426.666667S746.666667 85.333333 512 85.333333z m230.4 324.266667l-256 256c-12.8 12.8-34.133333 12.8-46.933333 0h4.266666c-4.266667 0-12.8-4.266667-17.066666-8.533333l-140.8-140.8c-12.8-12.8-12.8-34.133333 0-51.2 12.8-12.8 34.133333-12.8 51.2 0l128 128 234.666666-234.666667c12.8-12.8 34.133333-12.8 46.933334 0l4.266666 4.266667c4.266667 12.8 4.266667 34.133333-8.533333 46.933333z"
                              p-id="2574" fill="#00c3f9"></path>
                    </svg>
                    <svg v-else t="1662600718225" class="icon" viewBox="0 0 1024 1024" version="1.1"
                         xmlns="http://www.w3.org/2000/svg" p-id="2370" width="72" height="72">
                        <path d="M512 960c-247.039484 0-448-200.960516-448-448S264.960516 64 512 64 960 264.960516 960 512 759.039484 960 512 960zM512 128c-211.744443 0-384 172.255557-384 384s172.255557 384 384 384 384-172.255557 384-384S723.744443 128 512 128z"
                              p-id="2371" fill="#e6e6e6"></path>
                    </svg>
                    {{v.name}}
                </div>
            </div>
        </div>
        <div class="tip">* Đảm bảo sử dụng thanh toán MOMO-to-MOMO và thanh toán giữa ngân hàng với ngân hàng, các giao dịch từ ngân hàng đến MOMO có thể gây ra sự chậm trễ</div>
        <div class="pay-btn bg-color-blue" @click="recharge">Gửi đi</div>
    </div>
</template>

<script>
    import navTitle from "@components/navTitle"
    import {payment_create} from "../../api/user";

    export default {
        name: "rechargeCashSelect",
        components: {navTitle},
        data() {
            return {
                channel: 1011,
                money: this.$route.query.money,
                channel_list: [
                    {name: 'Ngân hàng trực tuyến để thanh toán', value: 1011},
                    {name: 'Chuyển khoản ngân hàng', value: 1012},
                    {name: 'Quét mã để thanh toán', value: 1013},
                    // {name: 'Zalo trả tiền', value: 1025},
                    {name: 'Momo trả tiền', value: 1027},
                    {name: 'VTpay trả tiền', value: 925}
                ]
            }
        },
        created() {
            this.initParam()
            console.log(this.channel_list)
        },
        methods: {
            initParam() {
                if (parseInt(this.money) < 50000) {
                    this.channel = 1027
                    this.channel_list = [
                        // {name: 'Zalo trả tiền', value: 1025},
                        {name: 'Momo trả tiền', value: 1027},
                        {name: 'VTpay trả tiền', value: 925}
                    ]
                } else {
                    this.channel = 1011
                    this.channel_list = [
                        {name: 'Ngân hàng trực tuyến để thanh toán', value: 1011},
                        {name: 'Chuyển khoản ngân hàng', value: 1012},
                        {name: 'Quét mã để thanh toán', value: 1013},
                        // {name: 'Zalo trả tiền', value: 1025},
                        {name: 'Momo trả tiền', value: 1027},
                        {name: 'VTpay trả tiền', value: 925}
                    ]
                }
            },
            getRadioVal(v) {
                this.channel = v.value
                console.log(this.channel)
            },
            recharge() {
                if (this.vnpropay_type === '') {
                    return this.$dialog.toast({mes: 'Vui lòng chọn hình thức thanh toán'});
                }
                if (this.vnpropay_type === 1011 || this.vnpropay_type === 1012 || this.vnpropay_type === 1013) {
                    if (this.money < 50000) {
                        return this.$dialog.toast({mes: 'Số tiền thanh toán mã quét không được nhỏ hơn 20000'});
                    }
                }
                payment_create({
                    amount: this.money,
                    vnpro_channel: this.channel
                }).then(res => {
                    this.$dialog.loading.close()
                    let pay_res = res.data
                    window.location.href = pay_res.link_url
                }).catch(res => {
                    this.$dialog.loading.close()
                    return this.$dialog.error(res.data.msg)
                })
            }
        }
    }
</script>

<style scoped>
    .amount {
        font-size: .5rem;
        background: #fff;
        width: 100%;
        padding: .4rem .2rem;
        color: darkgrey;
        margin-top: 1.1rem;
    }

    .channel {
        margin-top: .1rem;
    }

    .query-amount {
        float: right
    }

    .name {
        padding: .3rem .2rem;
        margin-top: .1rem;
        background: #fff;
    }

    .tip{
        font-size: .25rem;
        margin-top: .2rem;
        padding: 0 .2rem;
        color: red;
    }

    .pay-btn {
        display: block;
        width: 5.5rem;
        height: 0.86rem;
        margin: 0.5rem auto 0 auto;
        line-height: 0.86rem;
        text-align: center;
        color: #fff;
        border-radius: 0.15rem;
        font-size: 0.3rem;
        font-weight: bold;
    }
</style>